import { ArrowUp } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  dragActive: boolean
  withParent: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onUseParent: () => void
}

export const UploadInput: React.FC<Props> = ({
  dragActive,
  withParent,
  onChange,
  onUseParent,
}) => (
  <>
    <input
      id="input-file"
      type="file"
      name="image"
      className={css.upload_input_field}
      accept=".png,.jpg,.jpeg,.webp"
      onChange={onChange}
    />

    {!dragActive && (
      <label htmlFor="input-file" className={css.upload_input_label}>
        <ArrowUp className={css.upload_input_label_icon} />
        Upload
      </label>
    )}

    {!dragActive && withParent && (
      <button className={css.upload_input_button} onClick={onUseParent}>
        Use parent
      </button>
    )}
  </>
)
